import styled from 'styled-components';

export const TreeItemContainer = styled.div``;
